import { NgModule } from '@angular/core';
import { WorkerLookupComponent } from './worker-lookup.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@NgModule({
    declarations: [
        WorkerLookupComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        NgSelectModule,
    ],
    exports: [
        WorkerLookupComponent
    ]
})

export class WorkerLookupModule { }

